export default __webpack_public_path__ + "static/media/clear.75894f5e.svg";